// removed by extract-text-webpack-plugin
module.exports = {"EquipmentContainer":"EquipmentContainer","EquipmentContainer__heading":"EquipmentContainer__heading","EquipmentContainer__list":"EquipmentContainer__list","Accordion":"Accordion","Accordion__title":"Accordion__title","Accordion__title-pc":"Accordion__title-pc","Accordion__title-mb":"Accordion__title-mb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/equipment-container/styles.css
// module id = 840
// module chunks = 0 1